import { ScrollArea } from "@/components/ui/scroll-area";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

export default function Impressum({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[85vh] p-0" data-testid="impressum-dialog">
        <DialogHeader className="px-6 pt-6 pb-2">
          <DialogTitle className="font-['Manrope'] text-2xl font-bold text-slate-900">
            Impressum
          </DialogTitle>
          <DialogDescription className="text-sm text-slate-500">
            Angaben gemäß § 5 DDG
          </DialogDescription>
        </DialogHeader>
        <ScrollArea className="px-6 pb-6 max-h-[65vh]">
          <div className="space-y-6 text-sm text-slate-700 leading-relaxed pr-4">
            <section>
              <h3 className="font-semibold text-slate-900 mb-2">Anbieter</h3>
              <p>
                Lehnen & Weinacht<br />
                Pflegeberatung & Alltagsbegleitung<br />
                Hochstr. 72<br />
                47929 Grefrath<br />
                Nordrhein-Westfalen, Deutschland
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-slate-900 mb-2">Kontakt</h3>
              <p>
                Telefon: 0157 364 33 270<br />
                E-Mail: lehnenundweinacht@gmail.com
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-slate-900 mb-2">Vertreten durch</h3>
              <p>Dennis Lehnen<br />Karsten Weinacht</p>
            </section>

            <section>
              <h3 className="font-semibold text-slate-900 mb-2">Berufsbezeichnung und berufsrechtliche Regelungen</h3>
              <p>
                Pflegeberater/in nach § 7a SGB XI<br />
                Beratungseinsatz nach § 37 Abs. 3 SGB XI<br />
                Zuständige Aufsichtsbehörde: AOK Rheinland/Hamburg – HKP Gruppe
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-slate-900 mb-2">Umsatzsteuer-Identifikationsnummer</h3>
              <p>
                Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
                [USt-IdNr. einfügen, falls vorhanden]
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-slate-900 mb-2">Streitschlichtung</h3>
              <p>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
                <a
                  href="https://ec.europa.eu/consumers/odr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-cyan-700 hover:underline"
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
              </p>
              <p className="mt-2">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-slate-900 mb-2">Haftung für Inhalte</h3>
              <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen
                Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir
                als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
                Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
                rechtswidrige Tätigkeit hinweisen.
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-slate-900 mb-2">Haftung für Links</h3>
              <p>
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
                Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr
                übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
                oder Betreiber der Seiten verantwortlich.
              </p>
            </section>

            <div className="pt-4 border-t border-slate-200 text-xs text-slate-400">
              <p>
                <strong>Hinweis:</strong> Bitte ergänzen Sie die mit [Platzhalter] markierten Stellen
                mit Ihren tatsächlichen Angaben, bevor Sie die Website veröffentlichen.
              </p>
            </div>
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
